module.exports = __webpack_public_path__ + "img/excellent.8b3977e6.png";